import { addToCartAction, createNewCartAction } from "@/actions/cart";
import { getCartCookie } from "@/utils/cart/getCartCookie";
import type { CartProduct } from "@features/product/utils/toCartProduct";
import { setCartCookie } from "@server/utils/cart";

import { Market } from "@features/market/config/i18n-config";
import createCartItem from "./createCartItem";

export default async function addToCart(input: CartProduct[], market: Market) {
  const cartId = getCartCookie()?.value;
  const items = input.map((item) => createCartItem({ product: item }));

  if (!cartId) {
    const cart = await createNewCartAction({
      items,
      locale: market.locale,
    });

    setCartCookie({
      id: cart.id.toString(),
      token: cart.token,
    });

    return cart;
  }

  return addToCartAction({
    cartId,
    items,
    locale: market.locale,
  });
}
